import { render, staticRenderFns } from "./ArticleCreateDialog.vue?vue&type=template&id=4a1a4696&"
import script from "./ArticleCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./ArticleCreateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleCreateDialog.vue?vue&type=style&index=0&id=4a1a4696&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports